/* Waxit collection template: filter sheet, sort, load more, add-to-cart on cards, in-action media lightbox. */
(function () {
  /* (26 Sep 2026) Removed the old addToCart / filters handlers: their [data-wx-add] / [data-wxc-filters] markup no longer exists.
     Card add to cart lives in wx-card.js and the filter sheet in wx-collection-side.js. */
  /* In action lightbox: YouTube (optional start/end), Shopify mp4, or a photo. Nothing plays until clicked. */
  var lb;
  function lightbox() {
    if (lb) return lb;
    lb = document.createElement('div'); lb.className = 'wxc-lb'; lb.hidden = true; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="wxc-lb__box"><div class="wxc-lb__bar"><span data-lb-title></span><a data-lb-ext target="_blank" rel="noopener" hidden>Open on YouTube ›</a></div></div><button type="button" class="wxc-lb__x" aria-label="Close">×</button>';
    document.body.appendChild(lb);
    var close = function () { lb.hidden = true; document.body.classList.remove('wxc-lb-open'); lb.querySelectorAll('iframe, video, img').forEach(function (n) { n.remove(); }); };
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('.wxc-lb__x')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
    return lb;
  }
  function media(root) {
    root.querySelectorAll('[data-wxc-media]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var box = lightbox().querySelector('.wxc-lb__box'), t = b.dataset.wxcMedia, el, ext = lb.querySelector('[data-lb-ext]');
        lb.querySelectorAll('iframe, video, img').forEach(function (n) { n.remove(); });
        ext.hidden = true;
        if (t === 'yt') {
          var q = 'autoplay=1&rel=0&playsinline=1&origin=' + encodeURIComponent(location.origin);
          if (b.dataset.start && b.dataset.start !== '0') q += '&start=' + b.dataset.start;
          if (b.dataset.end && b.dataset.end !== '0') q += '&end=' + b.dataset.end;
          el = document.createElement('iframe'); el.src = 'https://www.youtube.com/embed/' + b.dataset.yt + '?' + q; el.title = b.dataset.title || 'Video'; el.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'; el.allowFullscreen = true; el.referrerPolicy = 'strict-origin-when-cross-origin';
          ext.href = 'https://www.youtube.com/watch?v=' + b.dataset.yt + (b.dataset.start && b.dataset.start !== '0' ? '&t=' + b.dataset.start : ''); ext.hidden = false;
        } else if (t === 'mp4') {
          el = document.createElement('video'); el.src = b.dataset.src; el.controls = true; el.autoplay = true; el.playsInline = true;
        } else {
          el = document.createElement('img'); el.src = b.dataset.src; el.alt = b.dataset.title || '';
        }
        box.insertBefore(el, box.firstChild);
        lb.querySelector('[data-lb-title]').textContent = b.dataset.title || '';
        lb.hidden = false; document.body.classList.add('wxc-lb-open');
      });
    });
  }
  /* Load more: the pager link is a real page-2 URL (crawlable, works without JS). With JS we fetch that page and append its cards in place.
     Pages loaded this way are remembered for this tab (sessionStorage, keyed by the URL), along with the scroll position when the
     shopper leaves. Coming Back to the collection re-appends those pages and returns to the same spot, instead of dropping them
     at the top of page 1. A fresh visit or a reload starts clean. */
  function mkey() { return 'wxc-more:' + location.pathname + location.search; }
  function mget() { try { return JSON.parse(sessionStorage.getItem(mkey()) || '{}'); } catch (e) { return {}; } }
  function mset(o) { try { var st = mget(); for (var k in o) st[k] = o[k]; sessionStorage.setItem(mkey(), JSON.stringify(st)); } catch (e) {} }
  function mclear() { try { sessionStorage.removeItem(mkey()); } catch (e) {} }
  function appendPage(nav, a, html) {
    var grid = nav.parentNode.querySelector('.wxc-grid__items');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var items = doc.querySelector('.wxc-grid__items'); if (!items || !grid) throw new Error('no grid');
    var first = null;
    Array.prototype.slice.call(items.children).forEach(function (c) { var n = document.importNode(c, true); if (!first) first = n; grid.appendChild(n); });
    /* Scope to the pager: product cards also use data-wxc-more on their "+N more" chip buttons (no href). */
    var next = doc.querySelector('[data-wxc-pager] [data-wxc-more]'), nextHref = next && next.getAttribute('href');
    if (nextHref) { a.href = nextHref; } else { a.remove(); }
    var s = nav.querySelector('[data-wxc-showing]'), start = parseInt(nav.dataset.start, 10) || 1;
    if (s) s.textContent = 'Showing ' + start + ' to ' + (start + grid.children.length - 1) + ' of ' + nav.dataset.total;
    if (window.okeWidgetApi && window.okeWidgetApi.initAllWidgets) window.okeWidgetApi.initAllWidgets();
    document.dispatchEvent(new CustomEvent('wx:variant')); /* wx-wishlist.js re-marks saved hearts on this */
    return first;
  }
  function loadMore(root) {
    root.querySelectorAll('[data-wxc-pager]').forEach(function (nav) {
      if (nav.dataset.bound) return; nav.dataset.bound = '1';
      nav.addEventListener('click', function (e) {
        var a = e.target.closest('[data-wxc-more]'); if (!a) return;
        if (!nav.parentNode.querySelector('.wxc-grid__items') || !window.fetch || !window.DOMParser) return;
        e.preventDefault();
        if (a.dataset.busy) return; a.dataset.busy = '1';
        var label = a.textContent, href = a.getAttribute('href'); a.textContent = 'Loading…';
        fetch(href, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var first = appendPage(nav, a, html);
            a.textContent = label; delete a.dataset.busy;
            var st = mget(), pages = st.pages || []; pages.push(href); mset({ pages: pages });
            var link = first && first.querySelector('a'); if (link) link.focus({ preventScroll: true });
          })
          .catch(function () { window.location.href = href; });
      });
    });
  }
  function restoreMore() {
    var nav = document.querySelector('[data-wxc-pager]'), a = nav && nav.querySelector('[data-wxc-more]');
    var entry = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var back = entry && entry.type === 'back_forward';
    var st = mget();
    if (!back) { mclear(); return; }
    var pages = (st.pages || []).slice(), y = st.y;
    if (!nav || !a || !pages.length || !window.fetch) { if (y) window.scrollTo(0, y); return; }
    var label = a.textContent; a.textContent = 'Loading…'; a.dataset.busy = '1';
    (function step(i) {
      if (i >= pages.length || !a.isConnected) { a.textContent = label; delete a.dataset.busy; if (y) window.scrollTo(0, y); return; }
      fetch(pages[i], { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { appendPage(nav, a, html); step(i + 1); })
        .catch(function () { a.textContent = label; delete a.dataset.busy; mset({ pages: pages.slice(0, i) }); });
    })(0);
  }
  /* Remember where the shopper was when they leave (opening a product, etc.). */
  window.addEventListener('pagehide', function () { if (document.querySelector('[data-wxc-pager]')) mset({ y: window.scrollY }); });
  function dots(root) {
    root.querySelectorAll('.wxc-inaction__grid').forEach(function (g) {
      if (g.dataset.dots) return; g.dataset.dots = '1';
      var d = g.parentNode.querySelector('.wxc-inaction__dots'); if (!d) return;
      var ds = d.children;
      g.addEventListener('scroll', function () {
        var i = Math.round(g.scrollLeft / (g.firstElementChild.offsetWidth + 10));
        for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('is-on', k === i);
      }, { passive: true });
    });
  }
  /* In action desktop slider: more than 3 cards becomes a 3-wide scroll track with prev/next arrows in the section head. Mobile keeps its swipe + dots. */
  function slider(root) {
    root.querySelectorAll('.wxc-inaction__grid').forEach(function (g) {
      if (g.dataset.slider) return; g.dataset.slider = '1';
      if (g.children.length <= 3) return;
      var head = g.parentNode.querySelector('.wxc-inaction__head'); if (!head) return;
      g.classList.add('is-slider');
      var nav = document.createElement('div'); nav.className = 'wxc-inaction__nav';
      nav.innerHTML = '<button type="button" data-dir="-1" aria-label="Previous">‹</button><button type="button" data-dir="1" aria-label="Next">›</button>';
      head.appendChild(nav);
      var prev = nav.children[0], next = nav.children[1];
      function step() { return g.firstElementChild.offsetWidth + 16; }
      function sync() { prev.disabled = g.scrollLeft <= 2; next.disabled = g.scrollLeft + g.clientWidth >= g.scrollWidth - 2; }
      nav.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; g.scrollBy({ left: step() * parseInt(b.dataset.dir, 10), behavior: 'smooth' }); });
      g.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }
  /* Featured product slider inside a media tile: one product visible, ‹ › flick between them. */
  function productSliders(root) {
    root.querySelectorAll('[data-wxc-products]').forEach(function (w) {
      if (w.dataset.bound) return; w.dataset.bound = '1';
      var t = w.querySelector('.wxc-tile__track'), prev = w.querySelector('[data-dir="-1"]'), next = w.querySelector('[data-dir="1"]');
      function sync() { prev.disabled = t.scrollLeft <= 2; next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2; }
      w.addEventListener('click', function (e) { var b = e.target.closest('.wxc-tile__pnav'); if (!b) return; e.preventDefault(); t.scrollBy({ left: t.clientWidth * parseInt(b.dataset.dir, 10), behavior: 'smooth' }); });
      t.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }
  /* Intro Read more. Phones: 3 lines. Desktop (30 Sep 2026): 6 lines, so long SEO descriptions (Rupes, Car Detailing Kits, Buffing Pads)
     don't push the products 1000px+ down the page. The full text stays in the page for Google. */
  function clamp(root) {
    var mob = window.matchMedia('(max-width: 989px)').matches;
    root.querySelectorAll('[data-wxc-clamp]').forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      var lines = parseFloat(getComputedStyle(el).lineHeight) * (mob ? 3.2 : 6.2);
      if (el.scrollHeight <= lines + 8) return;
      el.classList.add('is-clamped');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'wxc-readmore is-shown'; b.textContent = 'Read more'; b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () { var open = el.classList.toggle('is-clamped'); b.textContent = open ? 'Read more' : 'Read less'; b.setAttribute('aria-expanded', String(!open)); });
      el.parentNode.insertBefore(b, el.nextSibling);
    });
  }
  function boot(root) { loadMore(root); media(root); dots(root); slider(root); productSliders(root); clamp(root); }
  function first() { boot(document); restoreMore(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', first); else first();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Slider filters (e.g. Cut level / Finish level): a min-max slider that ticks the matching hidden tick boxes.
   Without JS the tick boxes show as normal. Full range = no filter. */
(function () {
  function initRanges(root) {
    (root || document).querySelectorAll('[data-wxc-range]').forEach(function (el) {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      var min = +el.dataset.min, max = +el.dataset.max;
      var lo = el.querySelector('[data-wxc-range-lo]'), hi = el.querySelector('[data-wxc-range-hi]');
      var out = el.querySelector('[data-wxc-range-out]');
      var boxes = el.querySelectorAll('input[type=checkbox]');
      if (!lo || !hi) return;
      el.classList.add('is-js');
      function sync(moved, touch) {
        var a = +lo.value, b = +hi.value;
        if (a > b) { if (moved === lo) { lo.value = b; a = b; } else { hi.value = a; b = a; } }
        if (out) out.textContent = a === b ? String(a) : a + ' to ' + b;
        var span = (max - min) || 1;
        el.style.setProperty('--lo', (a - min) / span);
        el.style.setProperty('--hi', (b - min) / span);
        lo.style.zIndex = (a === max) ? 3 : 2;
        if (!touch) return;
        var all = a === min && b === max;
        boxes.forEach(function (cb) { var v = +cb.value; cb.checked = !all && v >= a && v <= b; });
      }
      lo.addEventListener('input', function () { sync(lo, true); });
      hi.addEventListener('input', function () { sync(hi, true); });
      sync(null, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initRanges(); });
  else initRanges();
  document.addEventListener('shopify:section:load', function (e) { initRanges(e.target); });
})()